import {
	convertTimeWithUnitToSeconds,
	convertSecondsToNearestUnit,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { getMatchedConditionToEmitStep } from "assets/js/scenes/automations/containers/editor/Mapper";
import { convertPlanToFlatArrayOfActions } from "assets/js/scenes/automations/containers/editor/utils/utils";
import { getNextTarget } from "assets/js/scenes/automations/containers/editor/utils/utils";
const getSubSteps = (FEEvent, connectedEdges, events) => {
	switch (FEEvent.data.loopType) {
	case "continious": {
		const subSteps = [
			{
				name: FEEvent.id,
				params: [],
				type: "Loop",

				steps: [
					{
						name: FEEvent.id,
						action: "SubAutomation.Call",
						args: {
							sub_automation: "emit_next_step",
							params: {
								step: `${FEEvent.id}_loop`,
								delay: convertTimeWithUnitToSeconds(FEEvent.data.waitFor),
							},
						},
					},
				],
			},
		];

		return subSteps;
	}
	case "finite": {
		const subSteps = [
			{
				name: FEEvent.id,
				params: [],
				type: "Loop",
				steps: [
					{
						name: "loopinit",
						action: "Condition.Switch",
						args: {
							switch: [
								{
									steps: [
										{
											name: "addcurrentLoop",
											action: "Variable.Set",
											args: {
												[`input.data.loops.${FEEvent.id}`]: 0,
											},
										},
									],
									condition: {
										eq: {
											value: true,
											var: `\${not("${FEEvent.id}" in input.data.loops)}`,
										},
									},
								},
							],
						},
					},
					{
						name: FEEvent.id,
						action: "Condition.Switch",
						args: {
							switch: [
								{
									steps: [
										{
											name: "increment",
											action: "Variable.Set",
											args: {
												[`input.data.loops.${FEEvent.id}`]: `\${input.data.loops.${FEEvent.id} + 1}`,
											},
										},
										{
											name: "loopback",
											action: "SubAutomation.Call",
											args: {
												sub_automation: "emit_next_step",
												params: {
													step: `${FEEvent.id}_loop`,
													delay: convertTimeWithUnitToSeconds(
														FEEvent.data.waitFor
													),
												},
											},
										},
										{
											name: "done",
											action: "Return",
											return: true,
										},
									],
									condition: {
										lt: {
											value: parseInt(FEEvent.data.loopFor),
											var: `\${input.data.loops.${FEEvent.id}}`,
										},
									},
								},
							],
						},
						next: getNextTarget(connectedEdges, events),
					},
					{
						name: "reset",
						action: "Variable.Set",
						args: {
							[`input.data.loops.${FEEvent.id}`]: 0,
						},
					},
				],
			},
		];

		return subSteps;
	}
	default:
		break;
	}
};
const isContiniousOrFinite = (subStep) => {
	if (subStep.args.switch) return "finite";
	else return "continious";
};
// loop specific data are : goTo, loopFor, waitFor, loopType
const getLoopSpecificData = (automation, subStep) => {
	const loopType = isContiniousOrFinite(subStep);
	let waitFor = 0;
	let loopFor = null;
	let goTo = null;
	switch (loopType) {
	case "finite":
		{
			waitFor = convertSecondsToNearestUnit(
				subStep.args.switch[0].steps[1].args.params.delay
			);
			loopFor = subStep.args.switch[0].condition.lt.value;
			goTo = getMatchedConditionToEmitStep(
				convertPlanToFlatArrayOfActions(automation),
				subStep.args.switch[0].steps[1]
			)?.id;
		}
		break;

	case "continious":
		{
			waitFor = convertSecondsToNearestUnit(subStep.args.params.delay);
			goTo = getMatchedConditionToEmitStep(
				convertPlanToFlatArrayOfActions(automation),
				subStep
			)?.id;
		}
		break;
	}
	return {
		loopType: loopType,
		waitFor: waitFor,
		loopFor: loopFor,
		goTo: goTo,
	};
};
export { getSubSteps, getLoopSpecificData, isContiniousOrFinite };
